import { apiUrl } from '../config';

async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return {};
  }
}

function authHeaders(token) {
  const h = { Accept: 'application/json', 'Content-Type': 'application/json' };
  if (token) h.Authorization = `Bearer ${token}`;
  return h;
}

export async function postContact(payload) {
  const res = await fetch(apiUrl('/contact'), {
    method: 'POST',
    headers: { ...authHeaders(null), 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const body = await parseJson(res);
  if (!res.ok) {
    throw new Error(body.message || `Contact failed (${res.status})`);
  }
  return body.data;
}

export async function registerCustomer({ name, email, password, phone }) {
  const res = await fetch(apiUrl('/auth/register'), {
    method: 'POST',
    headers: authHeaders(null),
    body: JSON.stringify({ name, email, password, phone: phone || null }),
  });
  const body = await parseJson(res);
  if (!res.ok) {
    const msg = body.message || body.errors || `Register failed (${res.status})`;
    throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
  }
  return body.data;
}

export async function loginCustomer({ email, password }) {
  const res = await fetch(apiUrl('/auth/login'), {
    method: 'POST',
    headers: authHeaders(null),
    body: JSON.stringify({ email, password }),
  });
  const body = await parseJson(res);
  if (!res.ok) {
    const msg = body.message || (body.errors && JSON.stringify(body.errors)) || `Login failed (${res.status})`;
    throw new Error(typeof msg === 'string' ? msg : 'Login failed');
  }
  return body.data;
}

export async function logoutCustomer(token) {
  const res = await fetch(apiUrl('/auth/logout'), {
    method: 'POST',
    headers: authHeaders(token),
  });
  await parseJson(res);
}

export async function fetchMe(token) {
  const res = await fetch(apiUrl('/auth/me'), { headers: authHeaders(token) });
  const body = await parseJson(res);
  if (!res.ok) throw new Error(body.message || 'Session expired');
  return body.data;
}

export async function fetchMyOrders(token) {
  const res = await fetch(apiUrl('/my/orders'), { headers: authHeaders(token), cache: 'no-store' });
  const body = await parseJson(res);
  if (!res.ok) throw new Error(body.message || 'Could not load orders');
  return body.data?.orders || [];
}

export async function fetchMyOrder(token, orderId) {
  const res = await fetch(apiUrl(`/my/orders/${orderId}`), { headers: authHeaders(token), cache: 'no-store' });
  const body = await parseJson(res);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(body.message || 'Could not load order');
  return body.data;
}
